@if (percent() !== null) {
  <div class="margin-percent-row">
    <div class="margin-percent-track">
      <div
        class="margin-percent-fill"
        [style.width.%]="barWidth()"
        [style.background]="barColor()"
      ></div>
    </div>
    <span class="margin-percent-label" [style.color]="barColor()">
      {{ label() }}
    </span>
  </div>
}
